/**
 * Shared Quick Create helpers for React (+ optional vanilla re-use).
 * Extracted so React surfaces do not import the vanilla QuickCreatePopup class
 * only for icons / fetch-for-edit.
 */
import { ClientService } from '@vanilla/services/ClientService.js';
import { ContactService } from '@vanilla/services/ContactService.js';
import { UserService } from '@vanilla/services/UserService.js';

/** Static SVG for the "+" (create) icon — no user interpolation. */
export const QC_PLUS_ICON = `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <line x1="8" y1="3" x2="8" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <line x1="3" y1="8" x2="13" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
        `;

/** Static SVG for the pencil (edit) icon — no user interpolation. */
export const QC_EDIT_ICON = `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M10.5 2.5l3 3L5 14l-3.5.5L2 11 10.5 2.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
                <line x1="9" y1="4" x2="12" y2="7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
            </svg>
        `;

/**
 * Load an entity by id for Quick Create edit mode.
 * @param {'account'|'contact'|'user'|string} entityType
 * @param {string} id
 * @returns {Promise<object|null>}
 */
export async function fetchEntityForEdit(entityType, id) {
    if (!id) return null;
    try {
        if (entityType === 'account') return await ClientService.getById(id);
        if (entityType === 'contact') return await ContactService.getById(id);
        if (entityType === 'user') return await UserService.getById(id);
        return null;
    } catch (err) {
        console.warn(`Failed to fetch ${entityType} for quick edit:`, err);
        return null;
    }
}
